import React, { useEffect, useMemo, useState } from "react";
import close from "../Assets/Images/close.png";
import leaf from "../Assets/Images/leaf.png";
import wallet from "../Assets/Images/wallet.png";
import sale from "../Assets/Images/sell.png";
import { formatAmount } from "../utils/formatAmount";
import CustomInput from "./Inputs/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import UpdatePin from "./UpdatePin";
import { submitBooking } from "../store/actions/investment/submitBooking";
import Loader from "./Utils/Loader";
import { useNavigate } from "react-router-dom";

const AmountModal = ({
  handleClose,

  type,
  admin_fee,
  next,
  values,
  campaign,
}) => {
  const [amount, setAmount] = useState(0.0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isPinModalOpen, setIsPinModalOpen] = useState(false);
  const [expectedReturn, setExpectedReturn] = useState(0);
  const { pending } = useSelector((state) => state.dashboard);
  const user = useSelector((state) => state.onboarding?.user);
  const profile = useSelector((state) => state.onboarding?.profile);

  const opportunity = values;

  const walletBalance = useSelector(
    (state) => state?.dashboard?.halvestBalance?.data?.walletBalance,
  );
  const dollarBalance = useSelector(
    (state) => state?.dashboard?.halvestBalance?.data?.dollarBalance,
  );
  const _currency = opportunity?.currency === "USD" ? "$" : "₦";
  const balance = _currency === "$" ? dollarBalance : walletBalance;

  const formattedWalletBalance = new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
  }).format(walletBalance || 0);

  const usdFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(dollarBalance || 0);

  const adminFee = useMemo(() => {
    return type === "REAL_ESTATE" && values?.amount_per_unit
      ? (amount * values?.amount_per_unit * +admin_fee) / 100
      : (amount * +admin_fee) / 100;
  }, [admin_fee, amount]);

  const calculatedAmount = useMemo(() => {
    return type === "REAL_ESTATE" && values?.amount_per_unit
      ? adminFee + +amount * values?.amount_per_unit
      : adminFee + +amount;
  }, [amount, type, adminFee]);

  useEffect(() => {
    if (amount > -1) {
      const ROI =
        opportunity?.annual_roi && type === "REAL_ESTATE"
          ? opportunity?.annual_roi
          : opportunity?.roi;
      let total =
        opportunity?.amount_per_unit && type === "REAL_ESTATE"
          ? (ROI * amount * opportunity?.amount_per_unit) / 100
          : (ROI * amount) / 100;
      setExpectedReturn(total);
    }
  }, [
    amount,
    type,
    opportunity?.roi,
    opportunity?.amount_per_unit,
    opportunity?.annual_roi,
  ]);

  const [loadingUserBooking, setLoadingUserBooking] = useState(false);
  const userInterest = (amount, investment) => {
    setLoadingUserBooking(true);
    const data = {
      data:
        type === "REAL_ESTATE"
          ? {
              unit: Number(amount),
              property_product_id: Number(investment?.id),
              investment_type: "property",
            }
          : {
              amount: Number(amount),
              cycle_id: Number(investment?.id),
              investment_type: "business",
            },
      name: investment?.name,
      failed: () => {
        setLoadingUserBooking(false);
      },
      cb: () => {
        setLoadingUserBooking(false);
        handleClose();
      },
    };
    dispatch(submitBooking(data));
  };

  const openConfirmModal = (amount) => {
    if (false && amount > Number(opportunity?.leftover_amount)) {
      return toast.error(
        "Sorry! The amount you wish to invest exceeds the units left.",
      );
    }
    if (
      values?.status != "9" &&
      (!walletBalance || !dollarBalance || calculatedAmount > Number(balance))
    ) {
      return toast.error(
        // "Insufficient balance, click here to fund your wallet."
        "Insufficient balance.",
      );
    }

    if (!user?.hasSetPin) {
      toast.error("Create a Transaction PIN to proceed.");
      setIsPinModalOpen(true);
    } else if (false && amount < opportunity?.minimum_amount) {
      toast.error(
        `The minimum investment of (${_currency}${formatAmount(
          opportunity?.minimum_amount,
          0,
        )}) is not met by the amount of (${_currency}${formatAmount(
          amount,
          0,
        )}) that you wish to invest.`,
      );
    } else if (values?.status == "9") {
      userInterest(amount, values);
    } else {
      next({
        amount,
        adminFee,
        id: values?.id,
        name: values?.name,
        calculatedAmount,
        investment: values,
        campaign: campaign,
      });
    }
  };

  return isPinModalOpen ? (
    <div className="top-0 left-0 w-screen h-screen z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
      <UpdatePin
        small
        handleClose={() => {
          setIsPinModalOpen(false);
        }}
        next={(value) => {
          // setShowConfirmationModal(value);
          setIsPinModalOpen(false);
        }}
      />
    </div>
  ) : (
    <div className="flex flex-col justify-center items-center border-[1px] border-[#F0F0F5] w-[90%] sm:w-[553px] mt-[30px] mx-auto mb-[30px] h-[431px] rounded-[14px] shadow-xl relative bg-white">
      <div className="absolute top-5 right-6 cursor-pointer">
        <img
          src={close}
          alt="Close"
          className=" cursor-pointer w-6 h-6"
          onClick={handleClose}
        />
      </div>
      <div className="flex flex-col justify-center items-center w-full h-full">
        <h2 className="text-[16px] text-[#131E3D] font-[400] mb-4">
          {values?.status == "9" ? "Book a Slot in" : "Invest in"}{" "}
          {values?.name}
        </h2>

        <div className="flex px-6 w-full items-center gap-2 justify-center">
          <div
            className={`${
              type === "REAL_ESTATE" ? "max-w-[140px]" : ""
            } overflow-hidden`}
          >
            <CustomInput
              fullWidth
              noBorder
              bg={true}
              height={81}
              autoFocus={true}
              placeholder={type === "REAL_ESTATE" ? `Units` : ""}
              customTextStyle={{}}
              autoComplete={"off"}
              textInputCustomStyles={{
                textAlign: "center",
                fontSize: "54px",
                color: "#131e3d",
              }}
              variant={"standard"}
              selfValue={amount}
              maxLength={type === "REAL_ESTATE" ? 4 : 11}
              customType="amount"
              onChange={(e) => {
                setAmount(e.target.value);
              }}
            />
          </div>
          {type === "REAL_ESTATE" && amount ? (
            <h2 className="text-[32px] text-[#9C9C9E] font-[500]">
              Unit{amount == 1 ? "" : "s"}
            </h2>
          ) : (
            <></>
          )}
        </div>

        <div className=" mb-8 flex items-center gap-[5px] ">
          <img src={leaf} alt="" className=" w-[16px] h-[16px] " />
          <div className="  text-[14px] font-[400] text-[#04910A] ">
            {opportunity?.property_investment_type?.toLocaleLowerCase() ===
              "mudarabah" ||
            opportunity?.investment_type?.toLocaleLowerCase() ===
              "mudarabah" ? (
              `ROI Range (${opportunity?.roi_range?.min_roi} - ${opportunity?.roi_range?.max_roi}%)`
            ) : (
              <>
                {opportunity?.annual_roi && type === "REAL_ESTATE"
                  ? `Annual ROI (${opportunity?.annual_roi}%)`
                  : `Expected ROI (${opportunity?.roi}%)`}
                : {values?.currency === "USD" ? "$" : "₦"}
                {formatAmount(expectedReturn, 0)}
              </>
            )}
          </div>
        </div>
        {type === "REAL_ESTATE" ? (
          <div className="w-[90%] md:w-[459px]  flex justify-between  mb-3  items-center ">
            <h4 className="text-[14px] font-[400] text-[#9C9C9E]">
              Minimum Units: {Number(values?.minimum_unit)}
            </h4>
            <h4 className="text-[14px] font-[400] text-[#9C9C9E]">
              Maximum Units: {Number(values?.maximum_unit)}
            </h4>
          </div>
        ) : (
          <></>
        )}
        <div className=" h-[1px] mb-3 w-[90%] md:w-[459px] mx-auto  bg-[#F2F2F7] "></div>
        <div className="w-[90%] md:w-[459px]  flex justify-between  mb-8  items-center ">
          <div className="flex items-center gap-[8px]">
            <img src={sale} alt="" className=" w-[16px] h-[16px] " />
            <div className=" text-[14px] font-[400] text-[#9C9C9E] ">
              Admin Fee (
              {type === "REAL_ESTATE"
                ? admin_fee
                : opportunity?.regular_admin_fee}
              %)
            </div>
          </div>
          <div className=" text-[14px] font-[400] text-[#9c9c9e] ">
            {_currency} {adminFee ? formatAmount(adminFee, 0) : "0.00"}
          </div>
        </div>
        {values?.status == "9" ? (
          <div className="mb-6"></div>
        ) : (
          <div className="flex px-6 mb-5 gap-[5px] items-center ">
            <img src={wallet} alt="" className=" w-[14px] h-[14px] " />
            <div className="flex gap-[2px] flex-wrap justify-center text-[12px] font-[400] text-[#6935D3] ">
              <h4 className="text-center">
                {" "}
                Wallet Balance:{" "}
                {_currency === "$" ? usdFormatter : formattedWalletBalance}{" "}
              </h4>{" "}
            </div>
          </div>
        )}
        <button
          // navigate("/investment-summary/2");
          onClick={
            !profile?.id_verified
              ? () => navigate("/verify-id")
              : !amount || (pending && !walletBalance)
                ? null
                : () => openConfirmModal(amount, adminFee)
          }
          className={`min-w-[203px] px-4 h-[45px] rounded-[8px] bg-[#6935D3] shadow-sm justify-center items-center flex font-[500] text-[16px] text-white  ${
            !amount || (pending && !walletBalance)
              ? "opacity-85 cursor-not-allowed"
              : ""
          }`}
        >
          {loadingUserBooking ? (
            <Loader />
          ) : values?.status == "9" ? (
            "Submit Booking"
          ) : (
            `Pay ${_currency}${formatAmount(calculatedAmount, 0)}`
          )}
        </button>
      </div>
    </div>
  );
};

export default AmountModal;
